export const MEDIA = {
  image: {
    source:
      'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F86ec78d345f34d90888f452887179eed',
    width: 400,
    height: 344,
  },
  cta: {
    href: 'https://www.serasa.com.br/entrar?product=portal&redirectUrl=%2Farea-cliente%2Fmeu-cpf%2Fconsultas-cpf%2Ffree',
  },
}
